// extracted by mini-css-extract-plugin
export default {"loadingWrap":"URYVffVETVSIkPGB9P5E","needLoadingBackgroundMask":"lTXdcXGZu_Yguh1MG5vS","hiddenIcon":"wkokwJLUZ11M0pvkCY2s","common_bganimation":"kxwxCBGuT1hFawoVDrX6"};